import React, { useState, useEffect } from 'react';

const InternetStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showStatus, setShowStatus] = useState(false);

    useEffect(() => {
        // Hàm xử lý khi có mạng
        const handleOnline = () => {
            setIsOnline(true);
            setShowStatus(true); // Hiển thị thông báo khi kết nối lại
            setTimeout(() => setShowStatus(false), 5000); // Tự ẩn thông báo sau 5 giây
        };

        // Hàm xử lý khi mất mạng
        const handleOffline = () => {
            setIsOnline(false);
            setShowStatus(true); // Hiển thị thông báo khi mất mạng
        };

        // Gắn các sự kiện online/offline
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Dọn dẹp sự kiện khi component bị unmount
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <React.Fragment>
            {
                showStatus && (
                    <div
                        className={`internet-connection-status ${isOnline ? 'bg-success' : 'bg-danger'}`}
                    >
                        {isOnline
                            ? 'Kết nối internet đã được khôi phục!'
                            : 'Bạn đang ngoại tuyến. Vui lòng kiểm tra kết nối mạng.'}
                    </div>
                )
            }
        </React.Fragment>
    );
};

export default InternetStatus;
